export const CarouselHomeData = [
  {
    image:
      'https://i.imgur.com/5sJu3yG.jpg?1',
    caption: 'Donating helps to provide food',
  },
  {
    image:
      'https://i.imgur.com/9PNMsTF.jpg?2',
    caption: 'Donating helps to offer vet care',
  },
  {
    image:
      'https://i.imgur.com/DJbtDch.jpg?1',
    caption: 'Donating helps to keep dogs warm',
  },  {
    image:
      'https://i.imgur.com/DSq4JcR.jpg?1',
    caption: 'Donating helps to keep dogs happy',
  }
]